import { ContentType } from '../../Constants';

/**
 * Maps a PDF activity child content model to its docReader page (1-based).
 * `parentModel.childPages` keys are content object ids (see lesson JSON).
 */
function normalizePdfPage(page) {
  if (page == null || page === '') {
    return null;
  }
  const n = Number(page);
  return Number.isNaN(n) ? null : n;
}

function pdfPagesMatch(a, b) {
  const na = normalizePdfPage(a);
  const nb = normalizePdfPage(b);
  return na != null && nb != null && na === nb;
}

export function getPageForActivityChild(parentModel, childModel) {
  if (!parentModel || parentModel.type !== ContentType.PDF_ACTIVITY.type || !childModel) {
    return null;
  }
  const map = parentModel.childPages;
  if (!map || typeof map !== 'object') {
    return null;
  }
  const contentId = childModel.id;
  if (contentId != null && map[contentId] != null) {
    return normalizePdfPage(map[contentId]);
  }
  return null;
}

/**
 * Returns content ids of children pinned to the given page (for grouping in the flyout).
 * Wire these to `lessonElementId` via structureMap / lesson elements as needed.
 */
export function getContentChildIdsForPdfPage(parentModel, pageNum) {
  if (!parentModel?.childPages || pageNum == null) {
    return [];
  }
  return Object.entries(parentModel.childPages)
    .filter(([, page]) => pdfPagesMatch(page, pageNum))
    .map(([id]) => id);
}

/**
 * First activity child in lesson order that is pinned to `pageNum` in `childPages`.
 * When `filteredSlideIds` is set, only lesson element ids in that list are considered.
 */
export function getFirstLessonElementIdOnPdfPage(
  parentModel,
  pageNum,
  orderedLessonElementIds,
  getSlideModel,
  filteredSlideIds = null
) {
  if (!parentModel || parentModel.type !== ContentType.PDF_ACTIVITY.type || pageNum == null) {
    return null;
  }
  const map = parentModel.childPages;
  if (!map || typeof map !== 'object' || !orderedLessonElementIds?.length) {
    return null;
  }
  const filter = (filteredSlideIds && filteredSlideIds.length)
    ? new Set(filteredSlideIds)
    : null;
  for (const leId of orderedLessonElementIds) {
    if (filter && !filter.has(leId)) {
      continue;
    }
    const child = getSlideModel(leId);
    if (!child) {
      continue;
    }
    const contentId = child.id;
    if (contentId != null && map[contentId] != null && pdfPagesMatch(map[contentId], pageNum)) {
      return leId;
    }
  }
  return null;
}
